<template>
  <div class="container">
    <div class="btn-toolbar" role="toolbar">
      <button @click="saveConfig" id="comsave" class="btn btn-primary"><font-awesome-icon icon="save"/>&nbsp;Speichern</button><br/><br/>
    </div>
    <b-tabs class="mt-3">
      <b-tab title="Artikel">
        <CronExprBuilder ref="article" class="mt-3"/>
      </b-tab>
      <b-tab title="Preise">
        <CronExprBuilder ref="price" class="mt-3"/>
      </b-tab>
      <b-tab title="Kunden">
        <CronExprBuilder ref="customer" class="mt-3"/>
      </b-tab>
      <b-tab title="Aufträge">
        <CronExprBuilder ref="order" class="mt-3"/>
      </b-tab>
      <b-tab title="Kostenstellen">
        <CronExprBuilder ref="bshopdata" class="mt-3"/>
      </b-tab>
      <b-tab title="Konfiguration">
        <CronExprBuilder ref="config" class="mt-3"/>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import config from '@/modules/config.js'
import CronExprBuilder from '@/components/CronExprBuilder.vue'

export default {
  name: 'SyncSchedule',
  components: {
    CronExprBuilder
  },
  data() {
    return {
      needs: ["proxy.cron.order","proxy.cron.config","proxy.cron.customer","proxy.cron.price","proxy.cron.article","proxy.cron.bshopdata"],
      config: {},
    }
  },
  created: function() {
    var self = this;
    config.loadcfg(this.needs,this,function(data) {
      self.config = data;
      self.$refs.article.cron = data["proxy.cron.article"];
      self.$refs.price.cron = data["proxy.cron.price"];
      self.$refs.customer.cron = data["proxy.cron.customer"];
      self.$refs.order.cron = data["proxy.cron.order"];
      self.$refs.config.cron = data["proxy.cron.config"];
      self.$refs.bshopdata.cron = data["proxy.cron.bshopdata"];
    })
  },
  methods: {
    saveConfig: function() {
      this.config["proxy.cron.article"]  = this.$refs.article.cron;
      this.config["proxy.cron.price"]    = this.$refs.price.cron;
      this.config["proxy.cron.customer"] = this.$refs.customer.cron;
      this.config["proxy.cron.order"]    = this.$refs.order.cron;
      this.config["proxy.cron.config"]   = this.$refs.config.cron;
      this.config["proxy.cron.bshopdata"] = this.$refs.bshopdata.cron;
      var self = this;
      config.post(this,config.baseUrl + 'rest/jobs/config','Synchronisationsplanung speichern',JSON.stringify(this.config),function() {
        self.$bvToast.toast('Sync-Konfiguration gespeichert',{title:'Allgemein',variant: 'success'});
      })
    }
  }
}
</script>
